import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    Stack,
    Box
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { Utils } from 'core/utils';

function AdminCVEditDialog({ open, onClose, cv, onSave }) {
    const { register, handleSubmit, formState: { errors }, reset } = useForm({
        defaultValues: cv || {
            title: '',
            name: '',
            last_name: '',
            email: '',
            phone: '',
            website: '',
            city: '',
            address: '',
            description: '',
            interests: ''
        }
    });

    React.useEffect(() => {
        if (cv) {
            reset(cv);
        }
    }, [cv, reset]);

    const formatText = (value, fallback = '') => {
        if (!Utils.normalizeText) return value ?? fallback;
        return Utils.normalizeText(value, fallback);
    };

    const onSubmit = (data) => {
        onSave(data);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle>Edit CV</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} sx={{ mt: 1 }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="First Name"
                                    {...register('name')}
                                    defaultValue={formatText(cv?.name, '')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Last Name"
                                    {...register('last_name')}
                                    defaultValue={formatText(cv?.last_name, '')}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            fullWidth
                            label="CV Title *"
                            {...register('title', { required: 'Title is required' })}
                            error={!!errors.title}
                            helperText={errors.title?.message}
                            defaultValue={formatText(cv?.title, '')}
                        />
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    type="email"
                                    {...register('email')}
                                    defaultValue={formatText(cv?.email, '')}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    label="Phone"
                                    {...register('phone')}
                                    defaultValue={formatText(cv?.phone, '')}
                                />
                            </Grid>
                        </Grid>
                        <TextField
                            fullWidth
                            label="Website"
                            {...register('website')}
                            defaultValue={formatText(cv?.website, '')}
                        />
                        <TextField
                            fullWidth
                            label="City"
                            {...register('city')}
                            defaultValue={formatText(cv?.city, '')}
                        />
                        <TextField
                            fullWidth
                            label="Address"
                            {...register('address')}
                            defaultValue={formatText(cv?.address, '')}
                        />
                        <TextField
                            fullWidth
                            label="Description"
                            multiline
                            rows={2}
                            {...register('description')}
                            defaultValue={formatText(cv?.description, '')}
                        />
                        <TextField
                            fullWidth
                            label="Interests"
                            multiline
                            rows={2}
                            {...register('interests')}
                            defaultValue={formatText(cv?.interests, '')}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="contained">Save Changes</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

export default AdminCVEditDialog;

